import { createAsyncThunk, Dispatch } from '@reduxjs/toolkit';

import { removeCookie, deleteAccessToken } from '@backrs_ui/common-ui';

import { clearReturnToken } from '@backrs_ui/grow-ui/src/utils/emulation';

import { PostHog } from 'posthog-js';

import { logout } from './logout';
import { bookmarksApi } from '../bookmarks/bookmarks.api';
import { coachingAnalyticsApi } from '../coachingAnalytics/coachingAnalytics.api';
import { coachingDashboardApi } from '../coachingDashboard/coachingDashboard.api';
import { dashboardFeaturedApi } from '../dashboardFeatured/dashboardFeatured.api';
import { familyApi } from '../family/family.api';
import { generatedContentApi } from '../generatedContent/generatedContent.api';
import { institutionAdminApi } from '../institutionAdmin/institutionAdmin.api';
import { lifeReadinessApi } from '../lifeReadiness/lifeReadiness.api';
import { onboardingApi } from '../onboarding/onboarding.api';
import { clearStoredOperatorContext } from '../operatorContext/operatorContext';
import { prioritiesApi } from '../priorities/priorities.api';
import { profileApi } from '../profile/profile';
import { satActBoosterApi } from '../satActBooster/satActBooster.api';
import {
  SHARED_SESSION_GRANT_ID_KEY,
  SHARED_SESSION_RESOURCE_TYPE_KEY,
  sharedAccountSessionSlice,
} from '../sharedSession/sharedAccountSession';
import { solutionSessionApi } from '../solutionSession/solutionSession.api';
import { subscriptionApi } from '../subscription/subscriptionApi';
import { trackAssessmentApi } from '../trackAssessment/trackAssessment.api';
import { trackAssessmentApiLubav } from '../trackAssessment/trackAssessment.lubav.api';
import { userApi } from '../user/user.api';

export { logout } from './logout';

export const resetAllApiStates = (dispatch: Dispatch) => {
  dispatch(bookmarksApi.util.resetApiState());
  dispatch(lifeReadinessApi.util.resetApiState());
  dispatch(generatedContentApi.util.resetApiState());
  dispatch(onboardingApi.util.resetApiState());
  dispatch(prioritiesApi.util.resetApiState());
  dispatch(profileApi.util.resetApiState());
  dispatch(solutionSessionApi.util.resetApiState());
  dispatch(subscriptionApi.util.resetApiState());
  dispatch(trackAssessmentApi.util.resetApiState());
  dispatch(trackAssessmentApiLubav.util.resetApiState());
  dispatch(userApi.util.resetApiState());
  dispatch(sharedAccountSessionSlice.actions.deactivateSharedAccountSession());
  dispatch(familyApi.util.resetApiState());
  dispatch(coachingDashboardApi.util.resetApiState());
  dispatch(coachingAnalyticsApi.util.resetApiState());
  dispatch(institutionAdminApi.util.resetApiState());
  dispatch(dashboardFeaturedApi.util.resetApiState());
  dispatch(satActBoosterApi.util.resetApiState());
};

/** dispatch this thunk from components (the page shell) */
export const logoutThunk = createAsyncThunk(
  'auth/logoutThunk',
  async ({ postHog }: { postHog: PostHog }, { dispatch }) => {
    // first delete the access token & shared session data from localStorage
    deleteAccessToken('backrs_ui_token');
    localStorage.removeItem(SHARED_SESSION_GRANT_ID_KEY);
    localStorage.removeItem(SHARED_SESSION_RESOURCE_TYPE_KEY);
    clearStoredOperatorContext();
    // signing out while emulating leaves no account to return to
    clearReturnToken();

    // then remove the cookie
    removeCookie();

    // first dispatch the logout action so all slices can handle it
    dispatch(logout());

    // then reset all createAPI states
    resetAllApiStates(dispatch);

    postHog.capture('logout');
    postHog.reset();
  },
);
